
export function searchButton_click(event) {
	$w('#search').show();
	$w('#searchButton').style.backgroundColor = "rgb(47,50,65)";
}

export function header1_mouseOut(event) {
	$w('#search').hide();
	$w('#searchButton').style.backgroundColor = "rgb(189,43,52)";
}


export function mobileBoxSearch_click(event) {
	$w('#search').show();
	$w('#searchButton').style.backgroundColor = "rgb(47,50,65)";
}
